module.exports = __webpack_public_path__ + "static/media/delete-icon.59742abc.svg";